import type { CaptureLabelSchema } from '../api'

/** Labels grouped by category, uncategorized ("") first, then categories by
 *  name; labels keep their incoming (name) order within a group. */
export function groupByCategory(labels: CaptureLabelSchema[]): [string, CaptureLabelSchema[]][] {
  const groups = new Map<string, CaptureLabelSchema[]>()
  for (const label of labels) {
    const group = groups.get(label.category)
    if (group) group.push(label)
    else groups.set(label.category, [label])
  }
  return Array.from(groups.entries()).sort(([a], [b]) => a.localeCompare(b))
}
